import { z } from "zod";

const span = { startMs: z.number().nonnegative(), endMs: z.number().positive() };

export const railVisitSchema = z.object({
  characterId: z.string().min(1),
  vehicleId: z.string().min(1),
  ...span,
});

export const railAcquisitionSchema = z.object({
  characterId: z.string().min(1),
  fromCharacterId: z.string().min(1),
  ...span,
});
